import React from 'react'
import { Spin } from 'antd'
import users from '@services/users'
import { alertPopup } from '@utils/popup'

class ClientInvoice extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            extended: false,
            loading: false
        }
    }

    getPermit = () => {
        const { client_id, user_id } = this.props

        this.setState({ loading: true }, () => {
            users
                .getInvoicePermit({ client_id, user_id })

                .then(res => {
                    const href = window.location.href
                    const env = href.includes('localhost')
                        ? 'local'
                        : href.includes('admin-dev')
                        ? 'dev'
                        : href.includes('admin-stage')
                        ? 'stage'
                        : 'prod'

                    const url = `${this.mediwhoUrls[env]}/client-invoice?client_id=${client_id}&user_id=${user_id}`

                    // if ok
                    window.open(url, '_blank', 'noopener,noreferrer')
                    this.setState({ loading: false, extended: false })
                })
                .catch(error => {
                    console.log('error', error)
                    // Always reset loading so the button is not stuck spinning.
                    this.setState({ loading: false })
                    alertPopup({ type: 'error', title: 'אירעה שגיאה', body: '' })
                })
        })
    }

    mediwhoUrls = {
        local: 'http://localhost:3000',
        dev: 'https://app-dev.mediwho.com',
        stage: 'https://app-stage.mediwho.com',
        prod: 'https://www.mediwho.com'
    }

    render() {
        const { extended, loading } = this.state

        return (
            <div style={{ ...styles.wrapper }}>
                <button style={{ ...styles.mainButton }} onClick={() => this.setState({ extended: !extended })}>
                    {'אסמכתא'}
                </button>

                {extended && (
                    <div style={{ ...styles.dropdown }}>
                        <button
                            onClick={this.getPermit}
                            style={{
                                ...styles.button,
                                /*borderBottom: 'solid rgb(209, 209, 209) 1px',*/ position: 'relative'
                            }}
                        >
                            <span>{'צפייה'}</span>
                            {loading && <Spin size="small" style={{ position: 'absolute', margin: '2px 4px 0 0' }} />}
                        </button>
                        {/* <button style={{ ...styles.button }}>{'קישור'}</button> */}
                    </div>
                )}
            </div>
        )
    }
}

const styles = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column'
    },
    mainButton: {
        background: 'white',
        border: '1px solid rgb(209, 209, 209)',
        height: '34px',
        paddingInline: '15px',
        fontSize: '14px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        borderRadius: '4px'
    },
    dropdown: {
        background: 'white',
        border: '1px solid rgb(209, 209, 209)',
        height: '72px',
        paddingInline: '6px',
        fontSize: '14px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '4px',
        zIndex: 2,
        marginTop: 4
    },
    button: {
        background: 'none',
        border: 'none',
        padding: '0',
        height: '34px',
        width: '60px',
        cursor: 'pointer',
        outline: 'none'
    }
}

export default ClientInvoice
